import { Table, Tag } from 'antd'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { nokSignalen } from './queries'
import { copyToClipboard, sorter } from './helpers'

const dutchNames = {
  'bk': 'bk',
  'signalNaam': 'signaalnaam',
  'signalCode': 'code',
  'statusName': 'status',
  'beginOfLife': 'begin',
  'location': 'locatie'
}

const columns = ['bk', 'signalNaam', 'signalCode', 'statusName', 'beginOfLife', 'location']
  .map((key) => ({
    title: _.startCase(dutchNames[key]),
    dataIndex: key,
    key,
    sorter: (a, b) => sorter(a[key], b[key])
  }))
  columns[0].render = (list) => {
    return <>
      {list.map((item, i) => {
        return <span key={`item-bk-${i}`}>
          <Tag color={item.left > 0 ? 'orange' : 'red'}><b>{item.value}</b> {item.hours} / {item.ttr} TTR</Tag><br/>
        </span>
      })}
    </>;
  }
  columns[5].render = (list) => {
    return <>
      {list.map((item, i) => {
        return <span key={`item-location-${i}`}>{item}<br/></span>
      })}
    </>;
  }

const reduceNokSignalenData = (rows) => {
  const buildBkTiles = (resultCell, bol) => {
    const hours = Math.ceil((Number(new Date()) - Number(new Date(bol))) / 1000 / 60 / 60);
    return resultCell.children.bk.reduce((acc, item) => {
      item.children.ttr.forEach((it) => {
        const ttr = Number(it.value);
        const left = Math.max(0, Math.ceil(ttr - hours));
        acc.push({value: item.value, hours, left, ttr});
      });
      return acc;
    }, []);
  }
  const buildLocationTiles = (resultCell) => {
    return resultCell.children.trace.reduce((acc, item) => {
      item.children.location.forEach((it) => {
        acc.push(item.value + it.value);
      })
      return acc;
    }, []);
  }
  return rows.map((row, i) => ({
    key: i,
    bk: buildBkTiles(row.signalNaam[0], row.beginOfLife[0].value),
    signalCode: row.signalCode[0].value || "",
    signalNaam: row.signalNaam[0].value || "",
    statusName: row.statusName[0].value || "",
    beginOfLife: moment(row.beginOfLife[0].value).format('DD-MM-YYYY HH:mm') || "",
    location: buildLocationTiles(row.signalNaam[0])
  }))}


const NOKSignalen = ({ ...props }) => {

  const{ spaceId } = useParams();
  const { data, isLoading, error } = useQuery({
    queryKey: [`${spaceId}.nokSignalen.dashboard`],
    queryFn: async () => {
      const res = await new Weaver.Sparql(nokSignalen()).iterator(
        {'bk': 'signalNaam', 'ttr': 'bk', 'trace': 'signalNaam', 'location': 'trace'},
        'signalNaam',
        ((n)=>n?n.id():undefined),
        ((a)=>a?a.value:undefined),
      ).all();
      return res
    },
    refetchInterval: 5 * 60 * 1000
  })

  return (
    <Table
      title={data ? copyToClipboard(reduceNokSignalenData(data)) : () => null}
      pagination={{position: ["topRight", "none"]}}
      loading={isLoading}
      bordered={true}
      columns={columns}
      dataSource={data ? reduceNokSignalenData(data) : []}
      {...props}
    />
  )
}

NOKSignalen.title = "NOK Signalen"

export default NOKSignalen
